export enum TargetTypeEnum {
    Enemy = 'Enemy',
    Ally = 'Ally',
    Self = 'Self',
    // Add more as needed
}
